import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { /*makeStyles,*/ TextField } from '@material-ui/core';

const styles = theme => ({
    inputRoot: {
        '&$inputFocused $inputNotchedOutline': {
            borderColor: `${theme.palette.secondary.main} !important`,
            borderWidth: '2px',
        },
    },
    inputFocused: {},
    inputNotchedOutline: {
        borderWidth: '2px',
    },
    // inputNotchedOutlineError: {
    //     borderWidth: '2px',
    // },
    input: {
        fontSize: '16px',
    },
    inputMultiline: {
        padding: '20px',
    },
    helperText: {
        color: '#9B9E9C',
    },
    helperTextError: {
        color: 'red',
    },
});

const AfitdTextField = props => {
    const { classes, isHidden, children, error, ...otherProps } = props;
    const {
        inputRoot: inputRootCls,
        input: inputCls,
        inputFocused: inputFocusedCls,
        inputNotchedOutline: inputNotchedOutlineCls,
        // inputNotchedOutlineError: inputNotchedOutlineErrorCls,
        inputMultiline: inputMultilineCls,
        helperText: helperTextCls,
        helperTextError: helperTextErrorCls,
    } = classes;

    const InputProps = {
        classes: {
            root: inputRootCls,
            focused: inputFocusedCls,
            notchedOutline: inputNotchedOutlineCls,
            // error: inputNotchedOutlineErrorCls,
            input: inputCls,
            multiline: inputMultilineCls,
        },
    };

    const FormHelperTextProps = {
        className: error ? helperTextErrorCls : helperTextCls,
    };

    if (isHidden) {
        return null;
    } else {
        return <TextField fullWidth={true} variant="outlined" InputProps={InputProps} FormHelperTextProps={FormHelperTextProps} error={error} {...otherProps} />;
    }
};

export default withStyles(styles)(AfitdTextField);
